(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-goldenmate-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-about-banner')) {
    class GmAboutBanner extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-gm-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-gm-dot]'));
        this.badges = Array.from(this.querySelectorAll('[data-gm-badge]'));
        this.videoToggle = this.querySelector('[data-gm-video-toggle]');
        this.activeIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.counterFrames = new Map();
        this.handleClick = this.handleClick.bind(this);
        this.handleVisibility = this.handleVisibility.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.stopOnInteraction = this.stopAutoplay.bind(this);
        this.resumeAfterInteraction = this.startAutoplay.bind(this);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('mouseenter', this.stopOnInteraction);
        this.addEventListener('mouseleave', this.resumeAfterInteraction);
        this.addEventListener('focusin', this.stopOnInteraction);
        this.addEventListener('focusout', this.resumeAfterInteraction);
        document.addEventListener('visibilitychange', this.handleVisibility);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.body.classList.add('gm-about-banner-page');
        this.activate(this.activeIndex, false);
        this.observeBadges();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.badgeObserver?.disconnect();
        this.counterFrames.forEach((frame) => cancelAnimationFrame(frame));
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('mouseenter', this.stopOnInteraction);
        this.removeEventListener('mouseleave', this.resumeAfterInteraction);
        this.removeEventListener('focusin', this.stopOnInteraction);
        this.removeEventListener('focusout', this.resumeAfterInteraction);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        requestAnimationFrame(() => {
          if (!document.querySelector('[data-gm-about-banner]')) document.body.classList.remove('gm-about-banner-page');
        });
      }

      handleClick(event) {
        const previous = event.target.closest('[data-gm-prev]');
        const next = event.target.closest('[data-gm-next]');
        const dot = event.target.closest('[data-gm-dot]');
        const videoToggle = event.target.closest('[data-gm-video-toggle]');
        if (previous) this.activate(this.activeIndex - 1, true);
        if (next) this.activate(this.activeIndex + 1, true);
        if (dot) this.activate(Number(dot.dataset.gmDot), true);
        if (videoToggle) this.toggleVideo();
      }

      activate(index, restartAutoplay = true) {
        if (!this.slides.length) return;
        this.activeIndex = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          const video = slide.querySelector('video');
          if (!video) return;
          if (active && !this.reduceMotion) video.play().catch(() => {});
          if (!active) video.pause();
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
        this.syncVideoToggle();
        if (restartAutoplay) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      activeVideo() {
        return this.slides[this.activeIndex]?.querySelector('video');
      }

      syncVideoToggle() {
        if (!this.videoToggle) return;
        const video = this.activeVideo();
        this.videoToggle.hidden = !video;
        this.videoToggle.classList.toggle('is-paused', Boolean(video?.paused));
        this.videoToggle.setAttribute('aria-label', video?.paused ? 'Play banner video' : 'Pause banner video');
      }

      toggleVideo() {
        const video = this.activeVideo();
        if (!video) return;
        if (video.paused) video.play().catch(() => {});
        else video.pause();
        window.setTimeout(() => this.syncVideoToggle(), 0);
      }

      startAutoplay() {
        if (this.reduceMotion || this.dataset.autoplay !== 'true' || this.slides.length < 2 || document.hidden) return;
        this.stopAutoplay();
        this.autoplayTimer = window.setInterval(() => this.activate(this.activeIndex + 1, false), Number(this.dataset.interval) || 7000);
      }

      stopAutoplay() {
        if (!this.autoplayTimer) return;
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      handleVisibility() {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      }

      handleBlockSelect(event) {
        if (!this.contains(event.target)) return;
        const slide = event.target.closest('[data-gm-slide]');
        if (slide) this.activate(Number(slide.dataset.slideIndex), true);
      }

      observeBadges() {
        this.badges.forEach((badge) => this.revealBadge(badge));
      }

      revealBadge(badge) {
        badge.classList.add('is-visible');
        const counter = badge.querySelector('[data-gm-count]');
        if (!counter) return;
        const target = Number(counter.dataset.countTo);
        counter.textContent = target.toLocaleString();
      }

      resetBadge(badge) {
        badge.classList.remove('is-visible');
        const counter = badge.querySelector('[data-gm-count]');
        if (!counter) return;
        const frame = this.counterFrames.get(counter);
        if (frame) cancelAnimationFrame(frame);
        this.counterFrames.delete(counter);
        counter.textContent = '0';
      }
    }
    customElements.define('gm-about-banner', GmAboutBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-goldenmate-capabilities"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-collection-specs-v2')) {
    class GmCollectionSpecs extends HTMLElement {
      connectedCallback() {
        this.dialogs = Array.from(this.querySelectorAll('[data-gm-dialog]'));
        this.collectionTriggers = Array.from(this.querySelectorAll('[data-gm-open-dialog]'));
        this.collectionRail = this.querySelector('.gm-specs__collection-rail');
        this.collectionControls = Array.from(this.querySelectorAll('[data-gm-collection-direction]'));
        this.querySelectorAll('.gm-specs__product-image').forEach((image) => {
          image.draggable = false;
        });
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.handlePointerCancel = this.handlePointerCancel.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.updateCollectionControls = this.updateCollectionControls.bind(this);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('pointerdown', this.handlePointerDown);
        this.addEventListener('pointermove', this.handlePointerMove);
        this.addEventListener('pointerup', this.handlePointerUp);
        this.addEventListener('pointercancel', this.handlePointerCancel);
        this.collectionRail?.addEventListener('scroll', this.updateCollectionControls, { passive: true });
        this.dialogs.forEach((dialog) => dialog.addEventListener('close', this.handleDialogClose));
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        window.addEventListener('resize', this.handleResize, { passive: true });
        requestAnimationFrame(this.updateCollectionControls);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('pointerdown', this.handlePointerDown);
        this.removeEventListener('pointermove', this.handlePointerMove);
        this.removeEventListener('pointerup', this.handlePointerUp);
        this.removeEventListener('pointercancel', this.handlePointerCancel);
        this.collectionRail?.removeEventListener('scroll', this.updateCollectionControls);
        this.dialogs.forEach((dialog) => dialog.removeEventListener('close', this.handleDialogClose));
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        window.removeEventListener('resize', this.handleResize);
        clearTimeout(this.suppressClickTimer);
        this.suppressedClickZone = null;
        if (this.pageLocked) this.unlockPage();
      }

      handleClick(event) {
        const suppressedBackdropClick = this.suppressedClickZone && event.target.matches?.('[data-gm-dialog]');
        if (this.suppressedClickZone?.contains(event.target) || suppressedBackdropClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressedClickZone = null;
          clearTimeout(this.suppressClickTimer);
          return;
        }

        const collectionControl = event.target.closest('[data-gm-collection-direction]');
        if (collectionControl && this.contains(collectionControl)) {
          this.moveCollection(Number(collectionControl.dataset.gmCollectionDirection));
          return;
        }

        const opener = event.target.closest('[data-gm-open-dialog]');
        if (opener && this.contains(opener)) {
          this.openDialog(opener.dataset.gmOpenDialog);
          return;
        }

        const closer = event.target.closest('[data-gm-close]');
        if (closer && this.contains(closer)) {
          closer.closest('dialog')?.close();
          return;
        }

        const tab = event.target.closest('[data-gm-product-tab]');
        if (tab && this.contains(tab)) {
          const dialog = tab.closest('[data-gm-dialog]');
          this.activateProduct(dialog, Number(tab.dataset.gmProductTab), false);
          return;
        }

        if (event.target.matches('[data-gm-dialog]')) event.target.close();
      }

      handleKeydown(event) {
        const tab = event.target.closest('[data-gm-product-tab]');
        if (!tab) return;
        const dialog = tab.closest('[data-gm-dialog]');
        const tabs = Array.from(dialog.querySelectorAll('[data-gm-product-tab]'));
        const current = tabs.indexOf(tab);
        let next = current;
        if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        this.activateProduct(dialog, next, true);
      }

      handlePointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.suppressedClickZone = null;
        clearTimeout(this.suppressClickTimer);
        const collectionRail = event.target.closest('.gm-specs__collection-rail');
        if (collectionRail && collectionRail.scrollWidth > collectionRail.clientWidth) {
          this.pointerGesture = {
            type: 'collection',
            zone: collectionRail,
            pointerType: event.pointerType,
            pointerId: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            scrollLeft: collectionRail.scrollLeft,
            moved: false,
            captured: false
          };
          return;
        }

        const zone = event.target.closest('[data-gm-product-views], [data-gm-product-tabs]');
        if (!zone) return;
        this.pointerGesture = {
          type: 'product',
          zone,
          pointerId: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          moved: false,
          captured: false
        };
      }

      handlePointerMove(event) {
        const gesture = this.pointerGesture;
        if (!gesture || event.pointerId !== gesture.pointerId) return;
        const deltaX = event.clientX - gesture.x;
        const deltaY = event.clientY - gesture.y;
        if (Math.abs(deltaX) <= Math.abs(deltaY) || Math.abs(deltaX) < 12) return;
        gesture.moved = true;
        if (gesture.type === 'collection') {
          if (gesture.pointerType !== 'mouse') return;
          if (!gesture.captured) {
            gesture.zone.classList.add('is-dragging');
            gesture.zone.setPointerCapture?.(event.pointerId);
            gesture.captured = true;
          }
          gesture.zone.scrollLeft = gesture.scrollLeft - deltaX;
        } else if (!gesture.captured) {
          gesture.zone.setPointerCapture?.(event.pointerId);
          gesture.captured = true;
        }
        if (event.cancelable) event.preventDefault();
      }

      handlePointerUp(event) {
        const gesture = this.pointerGesture;
        if (!gesture || event.pointerId !== gesture.pointerId) return;
        this.pointerGesture = null;
        if (gesture.captured) gesture.zone.releasePointerCapture?.(event.pointerId);

        if (gesture.type === 'collection') {
          gesture.zone.classList.remove('is-dragging');
          if (gesture.moved) {
            this.suppressNextClick(gesture.zone);
            if (gesture.pointerType === 'mouse') this.snapCollectionRail(gesture.zone);
          }
          return;
        }

        const deltaX = event.clientX - gesture.x;
        const deltaY = event.clientY - gesture.y;
        if (!gesture.moved) return;
        this.suppressNextClick(gesture.zone);
        if (Math.abs(deltaX) < 36 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        if (event.cancelable) event.preventDefault();
        const dialog = gesture.zone.closest('[data-gm-dialog]');
        const tabs = Array.from(dialog.querySelectorAll('[data-gm-product-tab]'));
        const current = tabs.findIndex((tab) => tab.classList.contains('is-active'));
        const next = Math.max(0, Math.min(tabs.length - 1, current + (deltaX < 0 ? 1 : -1)));
        if (next !== current) {
          this.activateProduct(dialog, next, false);
        }
      }

      handlePointerCancel(event) {
        const gesture = this.pointerGesture;
        if (!gesture || event.pointerId !== gesture.pointerId) return;
        gesture.zone.classList.remove('is-dragging');
        if (gesture.captured) gesture.zone.releasePointerCapture?.(event.pointerId);
        if (gesture.type === 'collection' && gesture.moved) this.suppressNextClick(gesture.zone);
        this.pointerGesture = null;
      }

      suppressNextClick(zone) {
        this.suppressedClickZone = zone;
        clearTimeout(this.suppressClickTimer);
        this.suppressClickTimer = setTimeout(() => {
          this.suppressedClickZone = null;
        }, 400);
      }

      snapCollectionRail(rail) {
        const cards = Array.from(rail.querySelectorAll('.gm-specs__collection-card'));
        if (!cards.length) return;
        const center = rail.scrollLeft + rail.clientWidth / 2;
        const target = cards.reduce((closest, card) => {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const closestCenter = closest.offsetLeft + closest.offsetWidth / 2;
          return Math.abs(cardCenter - center) < Math.abs(closestCenter - center) ? card : closest;
        });
        const left = target.offsetLeft - (rail.clientWidth - target.offsetWidth) / 2;
        rail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }

      moveCollection(direction) {
        const rail = this.collectionRail;
        const cards = Array.from(rail?.querySelectorAll('.gm-specs__collection-card') || []);
        if (!rail || !cards.length || !direction) return;
        const center = rail.scrollLeft + rail.clientWidth / 2;
        const current = cards.reduce((closest, card) => {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const closestCenter = closest.offsetLeft + closest.offsetWidth / 2;
          return Math.abs(cardCenter - center) < Math.abs(closestCenter - center) ? card : closest;
        });
        const currentIndex = cards.indexOf(current);
        const nextIndex = Math.max(0, Math.min(cards.length - 1, currentIndex + direction));
        const target = cards[nextIndex];
        const left = target.offsetLeft - (rail.clientWidth - target.offsetWidth) / 2;
        rail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }

      updateCollectionControls() {
        const rail = this.collectionRail;
        if (!rail) return;
        const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
        this.collectionControls.forEach((control) => {
          const direction = Number(control.dataset.gmCollectionDirection);
          control.disabled = direction < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= maxScroll - 2;
        });
      }

      handleBlockSelect(event) {
        const trigger = this.collectionTriggers.find((item) => item.dataset.gmBlockId === event.detail.blockId);
        if (trigger) this.openDialog(trigger.dataset.gmOpenDialog);
      }

      handleResize() {
        if (!this.activeDialog) return;
        const activeTab = this.activeDialog.querySelector('[data-gm-product-tab].is-active');
        if (activeTab) this.positionIsland(this.activeDialog, activeTab);
      }

      openDialog(id) {
        const dialog = this.dialogs.find((item) => item.id === id);
        if (!dialog || dialog.open) return;
        this.lockPage();
        dialog.classList.add('is-switching-instantly');
        try {
          dialog.showModal();
        } catch (error) {
          dialog.classList.remove('is-switching-instantly');
          this.unlockPage();
          return;
        }
        this.activeDialog = dialog;
        const surface = dialog.querySelector('.gm-specs__dialog-surface');
        if (surface) {
          surface.scrollTop = 0;
          surface.scrollLeft = 0;
        }
        this.activateProduct(dialog, 0, false);
        requestAnimationFrame(() => {
          dialog.classList.remove('is-switching-instantly');
          const activeTab = dialog.querySelector('[data-gm-product-tab].is-active');
          if (activeTab) this.positionIsland(dialog, activeTab);
          dialog.querySelector('[data-gm-close]')?.focus({ preventScroll: true });
        });
      }

      handleDialogClose(event) {
        if (this.activeDialog !== event.currentTarget) return;
        this.unlockPage();
        this.activeDialog = null;
      }

      lockPage() {
        if (this.pageLocked) return;
        this.pageLocked = true;
        this.lockedScrollY = window.scrollY;
        this.previousHtmlOverflow = document.documentElement.style.overflow;
        this.previousBodyStyles = {
          position: document.body.style.position,
          top: document.body.style.top,
          left: document.body.style.left,
          right: document.body.style.right,
          width: document.body.style.width,
          overflow: document.body.style.overflow
        };
        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.lockedScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      }

      unlockPage() {
        if (!this.pageLocked) return;
        const scrollY = this.lockedScrollY || 0;
        const styles = this.previousBodyStyles || {};
        document.documentElement.style.overflow = this.previousHtmlOverflow || '';
        document.body.style.position = styles.position || '';
        document.body.style.top = styles.top || '';
        document.body.style.left = styles.left || '';
        document.body.style.right = styles.right || '';
        document.body.style.width = styles.width || '';
        document.body.style.overflow = styles.overflow || '';
        this.pageLocked = false;
        window.scrollTo(0, scrollY);
      }

      activateProduct(dialog, index, focus) {
        if (!dialog) return;
        const tabs = Array.from(dialog.querySelectorAll('[data-gm-product-tab]'));
        const panels = Array.from(dialog.querySelectorAll('[data-gm-product-panel]'));
        const productTrack = dialog.querySelector('[data-gm-product-track]');
        if (!Number.isInteger(index) || index < 0 || index >= tabs.length) return;
        tabs.forEach((tab, itemIndex) => {
          const active = itemIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, itemIndex) => {
          const active = itemIndex === index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
        });
        productTrack?.style.setProperty('--gm-product-offset', `${index * -100}%`);
        this.positionIsland(dialog, tabs[index]);
        if (focus) tabs[index].focus({ preventScroll: true });
      }

      positionIsland(dialog, activeTab) {
        const tablist = dialog?.querySelector('[data-gm-product-tabs]');
        if (!tablist || !activeTab) return;
        const update = () => {
          tablist.style.setProperty('--gm-island-x', `${activeTab.offsetLeft}px`);
          tablist.style.setProperty('--gm-island-width', `${activeTab.offsetWidth}px`);
          tablist.classList.add('is-ready');
        };
        update();
        requestAnimationFrame(update);
      }
    }

    customElements.define('gm-collection-specs-v2', GmCollectionSpecs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-goldenmate-energy-everywhere"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-energy-everywhere')) {
    class GmEnergyEverywhere extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('[data-gm-everywhere-reveal]');
        if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) { items.forEach((item) => item.classList.add('is-visible')); return; }
        this.observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); this.observer.unobserve(entry.target); } }), { threshold: .12 });
        items.forEach((item) => this.observer.observe(item));
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    }
    customElements.define('gm-energy-everywhere', GmEnergyEverywhere);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-goldenmate-growth"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-growth')) {
    class GmGrowth extends HTMLElement {
      connectedCallback() {
        this.chart = this.querySelector('[data-gm-growth-chart]');
        this.notesWrap = this.querySelector('[data-gm-notes]');
        this.viewport = this.querySelector('.gm-growth__notes-viewport');
        this.notes = Array.from(this.querySelectorAll('[data-gm-growth-note]'));
        this.points = Array.from(this.querySelectorAll('[data-gm-point]'));
        this.pages = Array.from(this.querySelectorAll('[data-gm-page]'));
        this.active = 0;
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onSelect = this.onSelect.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerEnd = this.handlePointerEnd.bind(this);
        this.handleNotesScroll = this.handleNotesScroll.bind(this);
        this.points.forEach((p) => p.addEventListener('click', this.onSelect));
        this.notes.forEach((n) => n.addEventListener('click', this.onSelect));
        this.pages.forEach((p) => p.addEventListener('click', this.onSelect));
        this.bindSwipe();
      }

      onSelect(event) {
        if (performance.now() < (this.suppressClickUntil || 0)) return;
        const el = event.currentTarget;
        const idx = Number(el.dataset.gmPoint ?? el.dataset.index ?? el.dataset.gmPage);
        if (Number.isNaN(idx)) return;
        this.select(idx);
      }

      select(idx, scroll) {
        const count = this.notes.length;
        if (!count) return;
        this.active = (idx + count) % count;
        this.points.forEach((p, i) => p.classList.toggle('is-active', i === this.active));
        this.notes.forEach((n, i) => n.classList.toggle('is-active', i === this.active));
        this.pages.forEach((p, i) => p.classList.toggle('is-active', i === this.active));
        const px = this.points[this.active]?.dataset.px;
        if (px) this.style.setProperty('--scrub-x', px + '%');
        if (scroll !== false) this.scrollToActive();
      }

      scrollToActive() {
        const vp = this.viewport;
        if (!vp || !this.isMobile()) return;
        const note = this.notes[this.active];
        if (note) note.scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }

      isMobile() { return matchMedia('(max-width: 749px)').matches; }

      bindSwipe() {
        const vp = this.viewport;
        if (!vp) return;
        vp.addEventListener('pointerdown', this.handlePointerDown);
        vp.addEventListener('pointermove', this.handlePointerMove);
        vp.addEventListener('pointerup', this.handlePointerEnd);
        vp.addEventListener('pointercancel', this.handlePointerEnd);
        vp.addEventListener('scroll', this.handleNotesScroll, { passive: true });
      }

      handlePointerDown(event) {
        if (!event.isPrimary || !this.isMobile()) return;
        this.pointerDrag = { id: event.pointerId, x: event.clientX, y: event.clientY, scrollLeft: this.viewport.scrollLeft, moved: false };
      }

      handlePointerMove(event) {
        if (!this.pointerDrag || event.pointerId !== this.pointerDrag.id) return;
        const deltaX = event.clientX - this.pointerDrag.x;
        const deltaY = event.clientY - this.pointerDrag.y;
        if (!this.pointerDrag.moved && (Math.abs(deltaX) < 6 || Math.abs(deltaX) <= Math.abs(deltaY))) return;
        this.pointerDrag.moved = true;
        if (!this.pointerDrag.captured) {
          this.viewport.setPointerCapture?.(event.pointerId);
          this.pointerDrag.captured = true;
        }
        this.viewport.classList.add('is-dragging');
        this.viewport.scrollLeft = this.pointerDrag.scrollLeft - deltaX;
        if (event.cancelable) event.preventDefault();
      }

      handlePointerEnd(event) {
        if (!this.pointerDrag || event.pointerId !== this.pointerDrag.id) return;
        const deltaX = event.clientX - this.pointerDrag.x;
        const moved = this.pointerDrag.moved;
        if (this.pointerDrag.captured) this.viewport.releasePointerCapture?.(event.pointerId);
        this.viewport.classList.remove('is-dragging');
        this.pointerDrag = null;
        if (event.type === 'pointercancel' || !moved || Math.abs(deltaX) < 38) return;
        this.suppressClickUntil = performance.now() + 320;
        this.select(this.active + (deltaX < 0 ? 1 : -1), true);
      }

      handleNotesScroll() {
        if (!this.isMobile()) return;
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const viewportCenter = this.viewport.getBoundingClientRect().left + this.viewport.clientWidth / 2;
          let closestIndex = 0;
          let closestDistance = Infinity;
          this.notes.forEach((note, index) => {
            const rect = note.getBoundingClientRect();
            const distance = Math.abs(rect.left + rect.width / 2 - viewportCenter);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          if (closestIndex !== this.active) this.select(closestIndex, false);
        }, 110);
      }

      disconnectedCallback() {
        clearTimeout(this.scrollTimer);
        if (!this.viewport) return;
        this.viewport.removeEventListener('pointerdown', this.handlePointerDown);
        this.viewport.removeEventListener('pointermove', this.handlePointerMove);
        this.viewport.removeEventListener('pointerup', this.handlePointerEnd);
        this.viewport.removeEventListener('pointercancel', this.handlePointerEnd);
        this.viewport.removeEventListener('scroll', this.handleNotesScroll);
      }
    }
    customElements.define('gm-growth', GmGrowth);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-goldenmate-mapped-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-mapped-stories')) {
    class GmMappedStories extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-gm-story-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-gm-story-panel]'));
        this.media = this.querySelector('[data-gm-story-media]');
        this.tabList = this.querySelector('[data-gm-story-tabs]');
        this.activeIndex = 0;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerEnd = this.handlePointerEnd.bind(this);
        this.handleTabScroll = this.handleTabScroll.bind(this);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        if (this.media) {
          this.media.addEventListener('pointerdown', this.handlePointerDown);
          this.media.addEventListener('pointermove', this.handlePointerMove);
          this.media.addEventListener('pointerup', this.handlePointerEnd);
          this.media.addEventListener('pointercancel', this.handlePointerEnd);
        }
        if (this.tabList) {
          this.tabList.addEventListener('pointerdown', this.handlePointerDown);
          this.tabList.addEventListener('pointermove', this.handlePointerMove);
          this.tabList.addEventListener('pointerup', this.handlePointerEnd);
          this.tabList.addEventListener('pointercancel', this.handlePointerEnd);
          this.tabList.addEventListener('scroll', this.handleTabScroll, { passive: true });
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        if (this.media) {
          this.media.removeEventListener('pointerdown', this.handlePointerDown);
          this.media.removeEventListener('pointermove', this.handlePointerMove);
          this.media.removeEventListener('pointerup', this.handlePointerEnd);
          this.media.removeEventListener('pointercancel', this.handlePointerEnd);
        }
        if (this.tabList) {
          this.tabList.removeEventListener('pointerdown', this.handlePointerDown);
          this.tabList.removeEventListener('pointermove', this.handlePointerMove);
          this.tabList.removeEventListener('pointerup', this.handlePointerEnd);
          this.tabList.removeEventListener('pointercancel', this.handlePointerEnd);
          this.tabList.removeEventListener('scroll', this.handleTabScroll);
        }
        window.clearTimeout(this.scrollTimer);
      }

      handleClick(event) {
        if (performance.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); return; }
        const tab = event.target.closest('[data-gm-story-tab]');
        if (!tab || !this.contains(tab)) return;
        this.activate(Number(tab.dataset.gmStoryTab), false, true);
      }

      handleKeydown(event) {
        const tab = event.target.closest('[data-gm-story-tab]');
        if (!tab || !this.contains(tab)) return;
        const current = this.tabs.indexOf(tab);
        let next = current;
        if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(next, true, true);
      }

      handleBlockSelect(event) {
        if (!(event.target instanceof Element) || !this.contains(event.target)) return;
        const tab = event.target.closest('[data-gm-story-tab]');
        if (tab) this.activate(Number(tab.dataset.gmStoryTab), false, true);
      }

      handlePointerDown(event) {
        if (!event.isPrimary || !window.matchMedia('(max-width: 989px)').matches) return;
        const source = event.currentTarget;
        this.pointerDrag = { id: event.pointerId, x: event.clientX, y: event.clientY, scrollLeft: this.tabList?.scrollLeft || 0, moved: false, source };
      }

      handlePointerMove(event) {
        if (!this.pointerDrag || event.pointerId !== this.pointerDrag.id) return;
        const deltaX = event.clientX - this.pointerDrag.x;
        const deltaY = event.clientY - this.pointerDrag.y;
        if (!this.pointerDrag.moved && (Math.abs(deltaX) < 6 || Math.abs(deltaX) <= Math.abs(deltaY))) return;
        this.pointerDrag.moved = true;
        if (!this.pointerDrag.captured) {
          this.pointerDrag.source.setPointerCapture?.(event.pointerId);
          this.pointerDrag.captured = true;
        }
        if (this.pointerDrag.source === this.tabList) {
          this.tabList.classList.add('is-dragging');
          this.tabList.scrollLeft = this.pointerDrag.scrollLeft - deltaX;
        }
        if (event.cancelable) event.preventDefault();
      }

      handlePointerEnd(event) {
        if (!this.pointerDrag || event.pointerId !== this.pointerDrag.id) return;
        const deltaX = event.clientX - this.pointerDrag.x;
        const source = this.pointerDrag.source;
        const moved = this.pointerDrag.moved;
        if (this.pointerDrag.captured) source.releasePointerCapture?.(event.pointerId);
        this.tabList?.classList.remove('is-dragging');
        this.pointerDrag = null;
        if (event.type === 'pointercancel' || !moved || Math.abs(deltaX) < 38) return;
        if (source === this.tabList) this.suppressClickUntil = performance.now() + 300;
        this.activate(this.activeIndex + (deltaX < 0 ? 1 : -1), false, true);
      }

      handleTabScroll() {
        if (!window.matchMedia('(max-width: 989px)').matches) return;
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => {
          const listCenter = this.tabList.getBoundingClientRect().left + this.tabList.clientWidth / 2;
          let closestIndex = 0;
          let closestDistance = Infinity;
          this.tabs.forEach((tab, index) => {
            const rect = tab.getBoundingClientRect();
            const distance = Math.abs(rect.left + rect.width / 2 - listCenter);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          if (closestIndex !== this.activeIndex) this.activate(closestIndex, false, false);
        }, 90);
      }

      activate(index, focusTab, scrollTab) {
        if (!this.tabs.length || !this.panels.length) return;
        const activeIndex = (index + this.tabs.length) % this.tabs.length;
        this.activeIndex = activeIndex;
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === activeIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === activeIndex;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
        });
        const activeTab = this.tabs[activeIndex];
        if (focusTab) activeTab.focus();
        if (scrollTab && window.matchMedia('(max-width: 989px)').matches) {
          activeTab.scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }

    customElements.define('gm-mapped-stories', GmMappedStories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-goldenmate-reliability"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-reliability')) {
    class GmReliability extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-gm-story-step]'));
        this.panels = Array.from(this.querySelectorAll('[data-gm-story-panel]'));
        this.media = this.querySelector('.gm-reliability__story-media');
        this.story = this.querySelector('[data-gm-scroll-story]');
        this.mobileQuery = matchMedia('(max-width: 749px)');
        this.isMobile = this.mobileQuery.matches;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.autoplaySpeed = Math.max(3000, Number(this.dataset.autoplaySpeed) || 5000);
        this.activeIndex = 0;
        this.handleClick = this.handleClick.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleMobileScroll = this.handleMobileScroll.bind(this);
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
        this.handleStoryVisibility = this.handleStoryVisibility.bind(this);
        this.pauseAutoplay = this.pauseAutoplay.bind(this);
        this.startAutoplay = this.startAutoplay.bind(this);
        const revealItems = this.querySelectorAll('[data-gm-reveal]');
        if (!('IntersectionObserver' in window) || this.reducedMotion) {
          revealItems.forEach((item) => item.classList.add('is-visible'));
        } else {
          this.revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); this.revealObserver.unobserve(entry.target); } }), { threshold: .12 });
          revealItems.forEach((item) => this.revealObserver.observe(item));
        }

        this.addEventListener('click', this.handleClick);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.activate(0);

        window.addEventListener('scroll', this.handleMobileScroll, { passive: true });
        window.addEventListener('resize', this.handleMobileScroll, { passive: true });
        this.mobileQuery.addEventListener?.('change', this.handleBreakpointChange);
        if (this.isMobile) {
          this.handleMobileScroll();
        } else {
          if ('IntersectionObserver' in window && this.story) {
            this.storyObserver = new IntersectionObserver(this.handleStoryVisibility, { threshold: .35 });
            this.storyObserver.observe(this.story);
          } else this.startAutoplay();
        }
      }
      disconnectedCallback() {
        this.revealObserver?.disconnect();
        this.storyObserver?.disconnect();
        this.pauseAutoplay();
        cancelAnimationFrame(this.mobileFrame);
        this.removeEventListener('click', this.handleClick);
        window.removeEventListener('scroll', this.handleMobileScroll);
        window.removeEventListener('resize', this.handleMobileScroll);
        this.mobileQuery?.removeEventListener?.('change', this.handleBreakpointChange);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }
      handleClick(event) {
        const step = event.target.closest('[data-gm-story-step]');
        if (!step || !this.contains(step)) return;
        this.activate(Number(step.dataset.gmStoryStep));
        if (!this.isMobile) this.restartAutoplay();
      }
      handleBlockSelect(event) {
        const step = event.target instanceof Element ? event.target.closest('[data-gm-story-step]') : null;
        if (step && this.contains(step)) {
          this.activate(Number(step.dataset.gmStoryStep));
          this.pauseAutoplay();
        }
      }
      handleMobileScroll() {
        if (!this.mobileQuery?.matches) return;
        if (this.mobileFrame) return;
        this.mobileFrame = requestAnimationFrame(() => {
          this.mobileFrame = null;
          if (!this.mobileQuery?.matches || !this.media || !this.steps.length) return;
          const visibleTop = Math.max(0, this.media.getBoundingClientRect().bottom);
          const visibleBottom = window.innerHeight;
          const visibleCenter = visibleTop + (visibleBottom - visibleTop) / 2;
          let active = this.activeIndex;
          let bestScore = -Infinity;
          this.steps.forEach((step, index) => {
            const rect = step.getBoundingClientRect();
            const overlap = Math.max(0, Math.min(rect.bottom, visibleBottom) - Math.max(rect.top, visibleTop));
            const distance = Math.abs(rect.top + rect.height / 2 - visibleCenter);
            const score = overlap - distance * .18;
            if (overlap > 0 && score > bestScore) {
              bestScore = score;
              active = index;
            }
          });
          this.activate(active);
        });
      }
      handleBreakpointChange(event) {
        this.isMobile = event.matches;
        if (this.isMobile) {
          this.pauseAutoplay();
          this.handleMobileScroll();
        } else {
          this.startAutoplay();
        }
      }
      handleStoryVisibility(entries) {
        if (entries.some((entry) => entry.isIntersecting)) this.startAutoplay();
        else this.pauseAutoplay();
      }
      startAutoplay() {
        if (this.isMobile || this.reducedMotion || !this.autoplayEnabled || this.steps.length < 2) return;
        this.pauseAutoplay();
        this.autoplayTimer = window.setInterval(() => this.activate((this.activeIndex + 1) % this.steps.length), this.autoplaySpeed);
      }
      pauseAutoplay() {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
      restartAutoplay() {
        this.pauseAutoplay();
        this.startAutoplay();
      }
      activate(index) {
        if (!Number.isInteger(index) || index < 0 || index >= this.steps.length) return;
        this.activeIndex = index;
        this.steps.forEach((step, stepIndex) => {
          const active = stepIndex === index;
          step.classList.toggle('is-active', active);
          step.setAttribute('aria-pressed', String(active));
        });
        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
        });
      }
    }
    customElements.define('gm-reliability', GmReliability);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-goldenmate-stats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-stats')) {
    class GmStats extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-gm-stat]'));
        this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.frames = new Map();
        if (!('IntersectionObserver' in window)) { this.items.forEach((i) => this.reveal(i)); return; }
        this.obs = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { this.reveal(e.target); this.obs.unobserve(e.target); } }), { threshold: .4 });
        this.items.forEach((i) => this.obs.observe(i));
      }
      disconnectedCallback() { this.obs?.disconnect(); this.frames.forEach((f) => cancelAnimationFrame(f)); }
      reveal(item) {
        item.classList.add('is-visible');
        const el = item.querySelector('[data-gm-count]');
        if (!el) return;
        const target = Number(el.dataset.countTo);
        const decimals = Number(el.dataset.decimals) || 0;
        if (this.reduce) { el.textContent = target.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }); return; }
        const start = performance.now();
        const step = (now) => {
          const p = Math.min((now - start) / 1300, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
          if (p < 1) this.frames.set(el, requestAnimationFrame(step));
        };
        this.frames.set(el, requestAnimationFrame(step));
      }
    }
    customElements.define('gm-stats', GmStats);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-goldenmate-thoughtful-design"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-thoughtful-design')) {
    class GmThoughtfulDesign extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('[data-gm-design-reveal]');
        if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) { items.forEach((item) => item.classList.add('is-visible')); return; }
        this.observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); this.observer.unobserve(entry.target); } }), { threshold: .12 });
        items.forEach((item) => this.observer.observe(item));
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    }
    customElements.define('gm-thoughtful-design', GmThoughtfulDesign);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-video-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-community-slider')) {
    class GmCommunitySlider extends HTMLElement {
      connectedCallback() {
        this.gallery = this.querySelector('[data-community-gallery]');
        this.previousButton = this.querySelector('[data-community-previous]');
        this.nextButton = this.querySelector('[data-community-next]');

        if (!this.gallery || !this.previousButton || !this.nextButton) return;

        this.handlePrevious = () => this.move(-1);
        this.handleNext = () => this.move(1);
        this.handleScroll = () => {
          cancelAnimationFrame(this.updateFrame);
          this.updateFrame = requestAnimationFrame(() => this.updateControls());
        };

        this.previousButton.addEventListener('click', this.handlePrevious);
        this.nextButton.addEventListener('click', this.handleNext);
        this.gallery.addEventListener('scroll', this.handleScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateControls());
          this.resizeObserver.observe(this.gallery);
        }

        this.updateControls();
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.gallery?.removeEventListener('scroll', this.handleScroll);
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.updateFrame);
      }

      move(direction) {
        const card = this.gallery.querySelector('.gm-community__card');
        if (!card) return;

        const gap = Number(getComputedStyle(this.gallery).columnGap.replace('px', '')) || 0;
        const distance = card.getBoundingClientRect().width + gap;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        this.gallery.scrollBy({ left: direction * distance, behavior });
      }

      updateControls() {
        const maximumScroll = this.gallery.scrollWidth - this.gallery.clientWidth;
        this.previousButton.disabled = this.gallery.scrollLeft <= 2;
        this.nextButton.disabled = this.gallery.scrollLeft >= maximumScroll - 2;
      }
    }

    customElements.define('gm-community-slider', GmCommunitySlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-goldenmate-benefits"] && !Shopify.designMode) return;
  try {
    
  const initializeMembershipBenefitRail = (root = document) => {
    root.querySelectorAll('.gm-member--benefits').forEach((section) => {
      const rail = section.querySelector('.gm-member__benefits-rail');
      const previous = section.querySelector('[data-gm-rail-direction="previous"]');
      const next = section.querySelector('[data-gm-rail-direction="next"]');
      if (!rail || !previous || !next || rail.dataset.railReady === 'true') return;

      const controller = new AbortController();
      const { signal } = controller;
      let animationFrame = 0;

      const updateButtons = () => {
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= maximum - 2;
      };

      const move = (direction) => {
        const card = rail.querySelector('.gm-member__info-card');
        if (!card) return;
        const gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
        rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      };

      const scheduleButtonUpdate = () => {
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(() => {
          animationFrame = 0;
          updateButtons();
        });
      };

      previous.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      rail.addEventListener('scroll', scheduleButtonUpdate, { passive: true, signal });
      window.addEventListener('resize', scheduleButtonUpdate, { passive: true, signal });
      signal.addEventListener('abort', () => window.cancelAnimationFrame(animationFrame), { once: true });
      section.gmBenefitRailController = controller;
      rail.dataset.railReady = 'true';
      updateButtons();
    });
  };

  initializeMembershipBenefitRail();
  document.addEventListener('shopify:section:load', (event) => initializeMembershipBenefitRail(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.gm-member--benefits').forEach((section) => {
      section.gmBenefitRailController?.abort();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-goldenmate-program"] && !Shopify.designMode) return;
  try {
    
  const initializeMembershipProgramRail = (root = document) => {
    root.querySelectorAll('.gm-member--program').forEach((section) => {
      const rail = section.querySelector('.gm-member__feature-grid');
      const previous = section.querySelector('[data-gm-program-direction="previous"]');
      const next = section.querySelector('[data-gm-program-direction="next"]');
      if (!rail || !previous || !next || rail.dataset.programRailReady === 'true') return;

      const controller = new AbortController();
      const { signal } = controller;
      let animationFrame = 0;

      const updateButtons = () => {
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= maximum - 2;
      };

      const move = (direction) => {
        const card = rail.querySelector('.gm-member__feature-card');
        if (!card) return;
        const gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
        rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      };

      const scheduleButtonUpdate = () => {
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(() => {
          animationFrame = 0;
          updateButtons();
        });
      };

      previous.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      rail.addEventListener('scroll', scheduleButtonUpdate, { passive: true, signal });
      window.addEventListener('resize', scheduleButtonUpdate, { passive: true, signal });
      signal.addEventListener('abort', () => window.cancelAnimationFrame(animationFrame), { once: true });
      section.gmProgramRailController = controller;
      rail.dataset.programRailReady = 'true';
      updateButtons();
    });
  };

  initializeMembershipProgramRail();
  document.addEventListener('shopify:section:load', (event) => initializeMembershipProgramRail(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.gm-member--program').forEach((section) => {
      section.gmProgramRailController?.abort();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-battery-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-battery-content')) {
    class ProductBatteryContent extends HTMLElement {
      connectedCallback() {
        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleTabKeydown = this.handleTabKeydown.bind(this);
        this.handleHashChange = this.handleHashChange.bind(this);
        this.updateStickyTop = this.updateStickyTop.bind(this);
        this.navigation = this.querySelector('[data-content-navigation]');
        this.navigation?.addEventListener('click', this.handleTabClick);
        this.navigation?.addEventListener('keydown', this.handleTabKeydown);
        window.addEventListener('hashchange', this.handleHashChange);
        window.addEventListener('popstate', this.handleHashChange);
        this.setupTabs({ useHash: true });
        this.revealSupportHash(window.location.hash, true);
        this.setupStickyOffset();

        if (this.dataset.hasVariantSpecs !== 'true') return;

        this.cache = new Map();
        this.handleVariantChange = this.handleVariantChange.bind(this);

        if (window.theme?.pubsub?.subscribe && window.theme?.pubsub?.PUB_SUB_EVENTS?.variantChange) {
          this.unsubscribe = window.theme.pubsub.subscribe(
            window.theme.pubsub.PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange
          );
        } else {
          document.addEventListener('variant:change', this.handleVariantChange);
          this.usesDomEvent = true;
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.headerResizeObserver?.disconnect();
        this.headerClassObserver?.disconnect();
        this.navigation?.removeEventListener('click', this.handleTabClick);
        this.navigation?.removeEventListener('keydown', this.handleTabKeydown);
        window.removeEventListener('hashchange', this.handleHashChange);
        window.removeEventListener('popstate', this.handleHashChange);
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
        if (this.usesDomEvent) document.removeEventListener('variant:change', this.handleVariantChange);
      }

      setupStickyOffset() {
        this.stickyHeader = document.querySelector('.header[is="sticky-header"]');
        if (!this.stickyHeader) {
          this.style.setProperty('--gm-battery-sticky-top', '8px');
          return;
        }

        this.headerSection = this.stickyHeader.closest('.header-section')
          || this.stickyHeader.closest('.shopify-section');
        if (window.ResizeObserver) {
          this.headerResizeObserver = new ResizeObserver(this.updateStickyTop);
          this.headerResizeObserver.observe(this.stickyHeader);
        }

        if (window.MutationObserver && this.headerSection) {
          this.headerClassObserver = new MutationObserver(this.updateStickyTop);
          this.headerClassObserver.observe(this.headerSection, {
            attributes: true,
            attributeFilter: ['class', 'data-sticky-type']
          });
        }

        this.updateStickyTop();
      }

      updateStickyTop() {
        if (!this.stickyHeader) return;
        const stickyType = this.headerSection?.dataset.stickyType
          || this.stickyHeader.dataset.stickyType
          || '';
        const headerHidden = this.headerSection?.classList.contains('header-hidden')
          || this.stickyHeader.classList.contains('header-hidden');
        const headerHeight = stickyType === 'on-scroll-up' && headerHidden
          ? 0
          : this.stickyHeader.getBoundingClientRect().height;
        this.style.setProperty('--gm-battery-sticky-top', `${Math.max(0, headerHeight) + 8}px`);
      }

      setupTabs({ useHash = false } = {}) {
        this.navigation = this.querySelector('[data-content-navigation]');
        this.tabs = this.navigation ? Array.from(this.navigation.querySelectorAll('[role="tab"][data-chapter]')) : [];
        this.panels = Array.from(this.querySelectorAll('[data-battery-tab-panel][data-chapter]'));
        if (!this.tabs.length || !this.panels.length) return;

        this.tabs.forEach((tab) => {
          const panel = this.panels.find((candidate) => candidate.dataset.chapter === tab.dataset.chapter);
          const hasContent = Boolean(panel && this.panelHasContent(panel));
          tab.hidden = !hasContent;
          tab.disabled = !hasContent;
        });

        const availableTabs = this.tabs.filter((tab) => !tab.hidden && !tab.disabled);
        if (!availableTabs.length) {
          this.panels.forEach((panel) => panel.hidden = false);
          return;
        }

        const serverSelectedTab = availableTabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
        this.defaultChapter ||= serverSelectedTab?.dataset.chapter || availableTabs[0]?.dataset.chapter || '';

        const hashChapter = useHash ? this.chapterFromHash(window.location.hash) : null;
        const currentChapter = this.activeChapter && availableTabs.some((tab) => tab.dataset.chapter === this.activeChapter)
          ? this.activeChapter
          : null;
        const selectedTab = availableTabs.find((tab) => tab.dataset.chapter === hashChapter)
          || availableTabs.find((tab) => tab.dataset.chapter === currentChapter)
          || availableTabs.find((tab) => tab.getAttribute('aria-selected') === 'true')
          || availableTabs[0];
        this.activateTab(selectedTab.dataset.chapter, { updateHash: false, focus: false });
      }

      panelHasContent(panel) {
        return Array.from(panel.children).some((child) => {
          if (child.matches('.gm-battery__chapter-anchor, .gm-battery__legacy-anchor')) return false;
          return (!child.hasAttribute('hidden') && child.textContent.trim() !== '')
            || Boolean(child.querySelector?.('img, video, section, article, dl'));
        });
      }

      chapterFromHash(hash) {
        const id = (hash || '').replace(/^#/, '');
        if (!id) return null;
        const exactTab = this.tabs?.find((tab) => tab.dataset.hashTarget === id);
        if (exactTab) return exactTab.dataset.chapter;
        const target = document.getElementById(id);
        if (!target || !this.contains(target)) return null;
        return target.closest('[data-battery-tab-panel]')?.dataset.chapter || null;
      }

      handleTabClick(event) {
        if (!(event.target instanceof Element)) return;
        const tab = event.target.closest('[role="tab"][data-chapter]');
        if (!tab || !this.navigation?.contains(tab) || tab.disabled) return;
        this.activateTab(tab.dataset.chapter, { updateHash: true, focus: false });
      }

      handleTabKeydown(event) {
        if (!(event.target instanceof Element)) return;
        const tab = event.target.closest('[role="tab"][data-chapter]');
        if (!tab || !this.navigation?.contains(tab)) return;
        const availableTabs = this.tabs.filter((candidate) => !candidate.hidden && !candidate.disabled);
        const currentIndex = availableTabs.indexOf(tab);
        let nextTab = null;
        if (event.key === 'ArrowRight') nextTab = availableTabs[(currentIndex + 1) % availableTabs.length];
        if (event.key === 'ArrowLeft') nextTab = availableTabs[(currentIndex - 1 + availableTabs.length) % availableTabs.length];
        if (event.key === 'Home') nextTab = availableTabs[0];
        if (event.key === 'End') nextTab = availableTabs[availableTabs.length - 1];
        if (event.key === 'Enter' || event.key === ' ') nextTab = tab;
        if (!nextTab) return;
        event.preventDefault();
        this.activateTab(nextTab.dataset.chapter, { updateHash: true, focus: true });
      }

      activateTab(chapter, { updateHash = false, focus = false } = {}) {
        const activeTab = this.tabs?.find((tab) => tab.dataset.chapter === chapter && !tab.hidden && !tab.disabled);
        const activePanel = this.panels?.find((panel) => panel.dataset.chapter === chapter);
        if (!activeTab || !activePanel) return;

        this.tabs.forEach((tab) => {
          const selected = tab === activeTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          const selected = panel === activePanel;
          if (!selected && !panel.hidden) this.pausePanelMedia(panel);
          panel.hidden = !selected;
        });
        this.activeChapter = chapter;
        if (focus) activeTab.focus({ preventScroll: true });
        if (updateHash) {
          const nextHash = `#${activeTab.dataset.hashTarget}`;
          if (window.location.hash !== nextHash) window.history.pushState(null, '', nextHash);
        }
      }

      pausePanelMedia(panel) {
        panel.querySelectorAll('video').forEach((video) => video.pause());
      }

      handleHashChange() {
        if (!window.location.hash) {
          this.activateTab(this.defaultChapter || this.tabs?.[0]?.dataset.chapter, { updateHash: false, focus: false });
          return;
        }
        const chapter = this.chapterFromHash(window.location.hash);
        if (chapter) {
          this.activateTab(chapter, { updateHash: false, focus: false });
          return;
        }
        this.revealSupportHash(window.location.hash, true);
      }

      revealSupportHash(hash, shouldScroll) {
        const id = (hash || '').replace(/^#/, '');
        const target = id ? document.getElementById(id) : null;
        if (!target || !this.contains(target) || target.closest('[data-battery-tab-panel]')) return;
        let disclosure = target.closest('details');
        while (disclosure && this.contains(disclosure)) {
          disclosure.open = true;
          disclosure = disclosure.parentElement?.closest('details');
        }
        if (shouldScroll) target.scrollIntoView({ block: 'start' });
      }

      handleVariantChange(event) {
        const payload = event?.data?.variant ? event.data : event?.detail;
        const variant = payload?.variant;
        const eventProductId = event?.data?.productId;
        if (!variant?.id) return;
        if (eventProductId && String(eventProductId) !== String(this.dataset.productId)) return;
        if (String(variant.id) === String(this.dataset.selectedVariantId)) return;
        this.loadVariant(variant.id);
      }

      async loadVariant(variantId) {
        this.abortController?.abort();
        const requestController = new AbortController();
        this.abortController = requestController;
        this.setBusy(true);

        try {
          let markup = this.cache.get(String(variantId));
          if (!markup) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url.toString(), {
              credentials: 'same-origin',
              signal: requestController.signal,
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (!response.ok) throw new Error(`Battery content request failed with ${response.status}`);
            markup = await response.text();
            this.cache.set(String(variantId), markup);
          }

          const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
          const nextSection = documentFragment.querySelector('product-battery-content');
          if (!nextSection) throw new Error('Battery content was not found in the section response.');

          this.querySelectorAll('[data-battery-variant-region]').forEach((currentRegion) => {
            const key = currentRegion.dataset.regionKey;
            const nextRegion = nextSection.querySelector(`[data-battery-variant-region][data-region-key="${key}"]`);
            if (!nextRegion) return;
            currentRegion.replaceChildren(...Array.from(nextRegion.childNodes, (node) => node.cloneNode(true)));
            currentRegion.toggleAttribute('hidden', nextRegion.hasAttribute('hidden'));
          });

          this.dataset.selectedVariantId = String(variantId);
          this.setupTabs();
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Unable to update battery specifications.', error);
        } finally {
          if (this.abortController === requestController) this.setBusy(false);
        }
      }

      setBusy(isBusy) {
        this.querySelectorAll('[data-battery-variant-region]').forEach((region) => {
          region.toggleAttribute('aria-busy', isBusy);
        });
      }
    }

    customElements.define('product-battery-content', ProductBatteryContent);
  }

  } catch(e) { console.error(e); }
})();
})();
